import { embackAxios } from "@/apis/emback/workbook";

/**
 * A tenant Offering as Sales Copilot lists it: the raw mk-argo document emback
 * proxies, narrowed to what Market Analyzer reads.
 */
export interface SalesCopilotOffering {
  _id: string;
  name: string;
  short_label?: string;
}

/**
 * Lists the caller's tenant Offerings through emback (`GET /offerings/raw`),
 * the same list Sales Copilot's offering picker shows.
 *
 * @returns The tenant's Offerings, in the order emback returns them.
 *
 * @example
 * ```typescript
 * const offerings = await fetchSalesCopilotOfferings();
 * ```
 */
export async function fetchSalesCopilotOfferings(): Promise<
  SalesCopilotOffering[]
> {
  const { data } =
    await embackAxios.get<SalesCopilotOffering[]>("/offerings/raw");
  return data;
}
